// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1wfXR","modalForm":"UpgradeEpcsModal_modalForm__12H5F","modalFooter":"UpgradeEpcsModal_modalFooter__1D8MJ"};